import React from "react";
import ShadeBackgound from "./ShadeBackgound";
import Card from "./Card";
import ErrorIcon from "../../assets/responsiveIcons/ErrorIcon";
import {  useConnectWallet } from "@web3-onboard/react";

function ConnectWalletError({ onClose }) {

  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const onConnectWallet = {

  }
  return (
    <>
      <ShadeBackgound onClik={onClose} opacity={0.3}></ShadeBackgound>
      <div
        onClick={onClose}
        className="absolute inset-0 z-20  flex justify-center items-center"
      >
        <Card className="px-5 py-6 flex flex-col items-center gap-5 ">
          <div className="mt-2">
            <ErrorIcon />
          </div>
          <div className="flex mt-1 flex-col items-center">
            <p className="text-3xl font-semibold">Info</p>
            <p className="text-sm w-60 break-words whitespace-normal text-center">
             Please connect wallet
            </p>
          </div>
          <button
            onClick={() => connect()}
            className="px-[0.68rem] py-4 text-sm bg-sunny-secondary dark:bg-dark-secondary rounded-sm"
          >
            Connect wallet
          </button>
        </Card>
      </div>
    </>
  );
}

export default ConnectWalletError;
